import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoginService } from '../ApplicationServices/login.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  public IsUserLoggedIn: boolean = true;
  public UserLoggedInSAPID: string;
  ServerErrorText$: BehaviorSubject<string> = new BehaviorSubject<string>('Server Error');

  //APIM Prod
   baseUrl: string ='https://edsprodapi.myhcl.com/CDSProd/api/';
   OcpApimSubscriptionKey: string = "";

  constructor(private route: Router) {
  }

  getSapId() {
    return localStorage.getItem("SapId");
  }
  setSapId(SapId: string) {
    localStorage.setItem("SapId", SapId);
  }
  getOnBehalf() {
    return sessionStorage.getItem("Onbehalf");
  }
  setOnBehalf(OnBehalf: string) {
    sessionStorage.setItem("Onbehalf", OnBehalf);
  }
  redirectIfInvalidUser() {
    this.route.navigate(['unauthorised']);
  }

  GetUserLoggedInSAPID() {
    if (this.UserLoggedInSAPID != null || this.UserLoggedInSAPID != undefined || localStorage.getItem('') != null) {
      return this.UserLoggedInSAPID;
    }
    else {
      this.route.navigate(['login']);
    }
  }
}
